module.exports = __webpack_public_path__ + "9d74d3bea7cc10eeb4b054135a40efea.png";